import { useEffect } from "react";

function setupPrintRestriction() {
  if (typeof window === "undefined") return;

  if (!document.querySelector("style[data-print-restriction]")) {
    const style = document.createElement("style");
    style.dataset.printRestriction = "true";
    style.innerHTML = `
      @media print {
        body {
          visibility: hidden !important;
        }
        body.print-allowed {
          visibility: visible !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  const handleKeyDown = (e: KeyboardEvent) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "p") {
      e.preventDefault();
      alert("프린트는 화면 내 버튼을 이용해주세요.");
    }
  };

  const handleContextMenu = (e: MouseEvent) => {
    e.preventDefault();
    alert("마우스 우클릭이 비활성화되었습니다.");
  };

  // 이벤트 리스너 추가
  window.addEventListener("keydown", handleKeyDown);
  window.addEventListener("contextmenu", handleContextMenu);

  // 컴포넌트 언마운트 시 이벤트 리스너 제거
  return () => {
    window.removeEventListener("keydown", handleKeyDown);
    window.removeEventListener("contextmenu", handleContextMenu);
    const style = document.querySelector("style[data-print-restriction]");
    if (style) document.head.removeChild(style);
  };
}

export function usePrintRestriction() {
  useEffect(() => {
    return setupPrintRestriction();
  }, []);
}
